module.exports = __webpack_public_path__ + "resources/img/img-acra-point-01.47cc8dec2b96811aff9e49fb7cf551a2.png";